<div class="container">
  <div class="error-content">
    <img src="assets/images/not-found.png" alt="error" class="w-50" />
    <h3>Page Not Found</h3>
    <p>
      The page you are looking for might have been removed had its name changed
      or is temporarily unavailable.
    </p>
    <a [routerLink]="['/transaction/list']" class="btn btn-primary border-0">
      Go to Dashboard
    </a>
  </div>
</div>
